import React, { useContext, useEffect } from 'react'
import { IFormElementProps, createSyntheticChangeEvent } from '@cicero/ui/forms'
import { Button, ListSubheader, MenuItem, Select, makeStyles } from '@cicero/ui'
import { IQuery } from 'models/helpers'
import { DEFAULT_CONDITIONS, IPageFilter, PAGE_FILTERS_TO_QUERY, PAGE_FILTER_DEFAULT, PageFilterOptionsContext } from '../models/filters'

export const PageFilters = ({ name, value, onChange, onQueryChange }: IPageFiltersProps) => {
  const { filterForm, filterFormRow, conditionForm, changeButton } = useFilterForm()
  const opts = useContext(PageFilterOptionsContext)

  const addFilter = () => {
    if (opts.length === 0) { return }
    onChange(createSyntheticChangeEvent(name, [...value, PAGE_FILTER_DEFAULT(opts[0])]))
  }

  const removeFilter = (index: number) => {
    onChange(createSyntheticChangeEvent(name, value?.filter((v, i) => i !== index) || []))
  }

  const changeFilter = (ev: any, key: string, index: number) => {
    if (!value) { return }
    const keyPos = ['property', 'condition', 'term']
    const pos = keyPos.indexOf(key)
    const currentRow = value[index]
    currentRow[pos] = ev.target.value
    const newValue = value?.map((v, i) => i === index ? currentRow : v) || []
    onChange(createSyntheticChangeEvent(name, newValue))
    if (onQueryChange) { onQueryChange(PAGE_FILTERS_TO_QUERY(newValue, opts)) }
    // LOGGER.debug('changing value for', ev, key, index)
  }

  useEffect(() => {
    if (value?.length === 0) { addFilter() }
  }, [value, opts])

  return <div className={filterForm}>
    {
      value?.map((row, i) => {
        if (!row) { return null }
        const [property, condition, term] = row
        const filter = opts.find(opt => opt.id === property)
        const activeCond = filter ? filter.conditions.find(cond => cond.id === condition) : undefined

        return <div key={i} className={filterFormRow}>
          <Select variant="outlined" value={property} onChange={(ev) => changeFilter(ev, 'property', i)}>
            { opts.map((opt, j) => {
              if (opt.type === 'header') { return <ListSubheader key={i} >{opt.label}</ListSubheader> }
              return <MenuItem key={j} value={opt.id}>{opt.label}</MenuItem>
            }) }
          </Select>
          <Select variant="outlined" className={conditionForm} value={condition} onChange={(ev) => changeFilter(ev, 'condition', i)}>
            { (filter?.conditions || DEFAULT_CONDITIONS).map((cond, j) => <MenuItem key={j} value={cond.id}>{cond.label}</MenuItem>) }
          </Select>
          {
            activeCond && activeCond.renderForm
              ? activeCond.renderForm(term, (val) => changeFilter({ target: { value: val } }, 'term', i))
              : filter && filter.renderForm
                ? filter.renderForm(term, (val) => changeFilter({ target: { value: val } }, 'term', i), activeCond)
                : <div></div>
          }
          {/* {(() => {
            if (condition === undefined) { return <div></div> }
            switch (condition) {
              default:
                return <TextField variant="outlined" value={term}  onChange={(ev) => changeFilter(ev, 'term', i)}/>
            }
          })()} */}
          {(() => {
            switch (i) {
              case value.length - 1:
                return <Button onClick={() => addFilter()} className={changeButton}>+</Button>
              default:
                return <Button onClick={() => removeFilter(i)} className={changeButton}>-</Button>
            }
          })()}
        </div>

      })
    }
  </div>
}

const useFilterForm = makeStyles({
  filterForm: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 450,
  },
  filterFormRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: 6,
    // justifyContent: 'f',

    '& > *': {
      minWidth: 100,
      flexGrow: 1,
      margin: 6,
    },
  },
  conditionForm: {
    maxWidth: 120,
  },
  changeButton: {
    maxWidth: 60,
  },
})

interface IPageFiltersProps extends IFormElementProps<IPageFilter[]> {
  onQueryChange?: (query: IQuery) => void
}

export const CONDITION_OPTIONS = {

}
